module.exports = __webpack_public_path__ + "static/media/book.869a0cd1.png";